import React from 'react';
import { LanguageProvider } from './i18n';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import RefundPage from './components/RefundPage';
import CheckoutSuccess from './components/CheckoutSuccess';
import MainApp from './components/MainApp';

export default function App() {
  const path = window.location.pathname;
  if (path === '/terms') return <LanguageProvider><TermsPage /></LanguageProvider>;
  if (path === '/privacy') return <LanguageProvider><PrivacyPage /></LanguageProvider>;
  if (path === '/refund') return <LanguageProvider><RefundPage /></LanguageProvider>;
  if (path === '/checkout/success') return <LanguageProvider><CheckoutSuccess /></LanguageProvider>;
  return <LanguageProvider><MainApp /></LanguageProvider>;
}